import React from 'react';
import { useCurrency } from 'contexts/CurrencyContext';

const buttonBase = {
  background: 'none',
  border: 'none',
  padding: '4px 6px',
  borderRadius: 4,
  display: 'flex',
  alignItems: 'center',
  transition: 'opacity 0.2s',
};

function CurrencyFlagSelector() {
  const { active, available, setActiveCurrency } = useCurrency();

  // Hide when only one (or zero) currencies are available
  if (available.length <= 1) return null;

  return (
    <div className="d-flex align-items-center" style={{ gap: 2, marginLeft: 12 }}>
      {available.map(({ currency, flag, label }) => {
        const isActive = currency === active.currency;
        return (
          <button
            key={currency}
            style={{
              ...buttonBase,
              opacity: isActive ? 1 : 0.35,
              cursor: isActive ? 'default' : 'pointer',
            }}
            onClick={() => !isActive && setActiveCurrency(currency)}
            title={label}
            aria-label={label}
            aria-pressed={isActive}
          >
            <i className={`flag flag-24 flag-${flag ?? currency.toLowerCase()}`} />
          </button>
        );
      })}
    </div>
  );
}

export default CurrencyFlagSelector;
